import { render, staticRenderFns } from "./isvDialog.vue?vue&type=template&id=6288853c&scoped=true"
import script from "./isvDialog.vue?vue&type=script&lang=js"
export * from "./isvDialog.vue?vue&type=script&lang=js"
import style0 from "./isvDialog.vue?vue&type=style&index=0&id=6288853c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6288853c",
  null
  
)

export default component.exports